package com.eladfinish.bible.contest.screens.chapterComplete.features.createCompletions

import com.eladfinish.bible.contest.screens.chapterComplete.model.UserCompletionsModel
import com.eladfinish.bible.contest.text.SpannableStringKMP
import kotlinx.collections.immutable.toImmutableList

class ToggleUserBlankUseCase(
    private val renderer: RenderUserCompletionsUseCase,
) {

    operator fun invoke(
        model: UserCompletionsModel,
        tokenIndex: Int,
    ): Output {

        val newVisibility = model.visibility
            .mapIndexed { i, v -> if (i == tokenIndex) !v else v }
            .toImmutableList()

        val newModel = model.copy(visibility = newVisibility)

        val newOutput = renderer(newModel)

        return Output(
            model = newModel,
            output = newOutput,
        )
    }

    data class Output(
        val model: UserCompletionsModel,
        val output: SpannableStringKMP,
    )
}
